var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styles.invoices},[_c('section',{staticClass:"fw-500",class:_vm.styles.invoice_content},[_c('span',[_vm._v("Billing date")]),_c('span',[_vm._v("Invoice number")]),_c('span',[_vm._v("Invoice total")]),_c('span',[_vm._v("Status")]),_c('span')]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }